import React, { Component } from 'react';

//head paths
import {basicHead} from './headPartsJs/1_basicHead.js';
import {twinTail} from './headPartsJs/twinTail.js';
import {tearDropHair} from './headPartsJs/tearDropHair.js';
import {sevenThree} from './headPartsJs/sevenThree.js';
import {devilHead} from './headPartsJs/devilHead.js';
import {catHead} from './headPartsJs/catHead.js';

//face paths
// import {basicFace} from './facePartsJs/1_basicFace.js';
// import {raisedEyebrows} from './facePartsJs/raisedEyebrows.js';
// import {eyelashes} from './facePartsJs/eyelashes.js';
// import {poutyMouth} from './facePartsJs/poutyMouth.js';
// import {glasses} from './facePartsJs/glasses.js';
// import {monkey} from './facePartsJs/monkey.js';
// import {devilFace} from './facePartsJs/devilFace.js';

//eyes parts
import {basicEyes} from './eyesPartsJs/basicEyes.js';
import {eyelashes} from './eyesPartsJs/eyelashes.js';
import {slantedEyes} from './eyesPartsJs/slantedEyes.js';
import {droopingEyes} from './eyesPartsJs/droopingEyes.js';
import {narrowSlantedEyes} from './eyesPartsJs/narrowSlantedEyes.js';
import {narrowDroopingEyes} from './eyesPartsJs/narrowDroopingEyes.js';
import {glasses} from './eyesPartsJs/glasses.js';

//eyeblows
import {slantedEyeblows} from './eyeblowsPartsJs/slantedEyeblows.js';
import {droopingEyeblows} from './eyeblowsPartsJs/droopingEyeblows.js';

//mouthParts
import {basicMouth} from './mouthPartsJs/basicMouth.js';
import {grin} from './mouthPartsJs/grin.js';
import {monkeyMouth} from './mouthPartsJs/monkeyMouth.js';
import {smirk} from './mouthPartsJs/smirk.js';
import {poutyMouth} from './mouthPartsJs/poutyMouth.js';
import {fangedMouth} from './mouthPartsJs/fangedMouth.js';
import {catMouth} from './mouthPartsJs/catMouth.js';

export default class FaceIconBaseComponent extends Component {
    constructor(props){
        super(props)
        this.state = {
            svgStyle:{
                fillRule:'evenodd',
                clipRule:'evenodd',
                strokeLinejoin:'round',
                strokeMiterlimit:1.41421,
            },

            headPaths:[
                {path:'',key:'none'},
                {path:basicHead,key:'basic'},
                {path:tearDropHair,key:'tearDropHair'},
                {path:twinTail,key:'twinTail'},
                {path:sevenThree,key:'sevenThree'},
                {path:devilHead,key:'devil'},
                {path:catHead,key:'cat'},
            ],

            // facePaths:[
            //     {path:'',key:'none'},
            //     {path:basicFace,key:'basic'},
            //     {path:raisedEyebrows,key:'raisedEyebrows'},
            //     {path:eyelashes,key:'eyelashes'},
            //     {path:poutyMouth,key:'pouty'},
            //     {path:glasses,key:'glasses'},
            //     {path:monkey,key:'monkey'},
            //     {path:devilFace,key:'devil'},
            // ],

            eyePaths:[
                {path:'',key:'none'},
                {path:basicEyes,key:'basic'},
                {path:eyelashes,key:'eyelashes'},
                {path:slantedEyes,key:'slanted'},
                {path:droopingEyes,key:'drooping'},
                {path:narrowSlantedEyes,key:'narrowSlanted'},
                {path:narrowDroopingEyes,key:'narrowDrooping'},
                {path:glasses,key:'glasses'},
            ],

            eyeblowPaths:[
                {path:'',key:'none'},
                {path:slantedEyeblows,key:'slanted'},
                {path:droopingEyeblows,key:'drooping'},
            ],

            mouthPaths:[
                {path:'',key:'none'},
                {path:basicMouth,key:'basic'},
                {path:grin,key:'grin'},
                {path:monkeyMouth,key:'monkey'},
                {path:smirk,key:'smirk'},
                {path:poutyMouth,key:'pouty'},
                {path:fangedMouth,key:'fanged'},
                {path:catMouth,key:'cat'},
            ],

            
        }
    }

    componentDidMount = () => {
        //setTimeoutは一応。顔data取得のタイムラグがあったりする場合のため（そうならないように作るのが前提）
        setTimeout(() => {
            if(this.props.onGetImageData !== undefined){
                this.svg2jpeg(this.refs.faceSvgRef, (imgData) => {
                    //image nodeそのものを返してきている
                    this.props.onGetImageData(imgData);
                }, (error) => {
                    //error: 何らかのエラーオブジェクト 
                })
            }
        },100)
    }

    //imageData取得用
    svg2jpeg(svgElement, sucessCallback, errorCallback){

        //safariのためにscaleを使う
        const scaleNumber = 10;
        var canvas = document.createElement('canvas');
        canvas.width = 80 * scaleNumber;        
        canvas.height = 80 * scaleNumber;
        var ctx = canvas.getContext('2d');
        ctx.scale(scaleNumber,scaleNumber);

        var image = new Image();
        
        image.onload = () => {
          // SVGデータをPNG形式に変換する
          //この設定でsafari,chromeともにうまくいった。なぜかは…わからん 80 80 でないとダメ
          ctx.drawImage(image, 0, 0,80,80);                
          sucessCallback(canvas.toDataURL("image/png"));
          // sucessCallback(image);
        };
        image.onerror = (e) => {
          errorCallback(e);
        };
        // SVGデータを取り出す
        var svgData = new XMLSerializer().serializeToString(svgElement);
        
        image.src = 'data:image/svg+xml;charset=utf-8;base64,' + btoa(svgData);        
        
    }



    render(){
      
        const customStyle = {lineHeight:0}

        const joinedPath = () => {
            const headPathObject = this.state.headPaths.find((value) => {
                return ( value.key === this.props.head )
            })

            const eyesPathObject = this.state.eyePaths.find((value) => {
                return ( value.key === this.props.eyes )
            })  

            const eyeblowsPathObject = this.state.eyeblowPaths.find((value) => {
                return ( value.key === this.props.eyeblows )
            })

            const mouthPathObject = this.state.mouthPaths.find((value) => {
                return ( value.key === this.props.mouth )
            })            

            return (
                (headPathObject !== undefined ? headPathObject.path : '')
                + (eyesPathObject !== undefined ? eyesPathObject.path : '')
                + (eyeblowsPathObject !== undefined ? eyeblowsPathObject.path : '')
                + (mouthPathObject !== undefined ? mouthPathObject.path : '')
            );
        }

        const fillStyle = {fill:this.props.fillColor}

        return (
            <div style={customStyle}>
              <svg viewBox="0 0 80 80" style={this.state.svgStyle} ref="faceSvgRef">
              {/* <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.state.svgStyle}> */}
                <g style={fillStyle}>
                  <path d={ joinedPath()}/>
                </g>
              </svg>
            </div>
        )
    }
}

// Propsのデフォルト値
FaceIconBaseComponent.defaultProps = {
    head:'basic',
    eyes:'basic',
    eyeblows:'none',
    mouth:'basic',
    face_ex:'none',
    fillColor: '#666666',
};
